import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_EMPLOYEES_LIST = Symbol('personnel.personnel-list');

export const EMPLOYEES_MAIN_ROUTE_NAME = Symbol('personnel');
export const EMPLOYEES_LIST_ROUTE_NAME = Symbol('personnel.personnel-list');

export const EMPLOYEES_LIST_QUERY_KEY = 'employees-list';
export const EMPLOYEES_LIST_API_URL = 'admin/personals/list_personals';

export const CHANGE_EMPLOYEE_STATUS_MUTATION_KEY = 'employee-change-status';
export const CHANGE_EMPLOYEE_STATUS_API_URL = 'admin/personals/:id/change_ban_status';

export const EMPLOYEES_LIST_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.PERSONALS_SHOW),
  CREATE: new Permission(PermissionsList.admin.PERSONALS_CREATE),
  EDIT: new Permission(PermissionsList.admin.PERSONALS_EDIT),
  BAN: new Permission(PermissionsList.admin.PERSONALS_CHANGE_BAN_STATUS),
};
